export default __webpack_public_path__ + "static/media/07_Amrakis.ad12096d.jpg";